const TAKE_LIMIT = 15;

export const appendStringToUri = (
  filter_name: string,
  filter_value: any,
  uri: string
) => {
  return appendStringFilterToUri(filter_name, filter_name, filter_value, uri);
};

export const appendStringFilterToUri = (
  filter_item: string,
  filter_name: string,
  filter_value: any,
  uri: string
) => {
  // console.log(filter_value);
  if (filter_item === filter_name && filter_value.toString().length > 0) {
    if (!uri.endsWith("?")) {
      uri = uri.concat("&" + filter_name + "=", filter_value);
    } else {
      uri = uri.concat(filter_name + "=", filter_value);
    }
  }

  return uri;
};

export const appendNumberToUri = (
  filter_name: string,
  filter_value: any,
  uri: string
) => {
  return appendNumberFilterToUri(filter_name, filter_name, filter_value, uri);
};

export const appendNumberFilterToUri = (
  filter_item: string,
  filter_name: string,
  filter_value: any,
  uri: string
) => {
  if (filter_item === filter_name) {
    if (!uri.endsWith("?")) {
      uri = uri.concat("&" + filter_name + "=", filter_value);
    } else {
      uri = uri.concat(filter_name + "=", filter_value);
    }
  }

  return uri;
};

export const computeSkip = (page: number): number => {
  let skip = 0;
  let take = TAKE_LIMIT;
  if (page > 0) skip = page * take;
  return skip;
};
